import { ModalV3 } from '@jouzen/ecom-components';

import Video from '@/app/components/Video';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const Gen4VideoModal = (): JSX.Element => {
  const { or4VideoVisible, setOr4VideoVisible } = useSizingPageModalContext();
  const toggleModal = () => {
    setOr4VideoVisible(false);
  };

  return (
    <ModalV3
      isOpen={or4VideoVisible}
      onOpenChange={toggleModal}
      padding="large"
      size="large"
    >
      <div className="px-6 xl:px-24">
        <div className="aspect-video" data-cy="gen4-sizing-video-wrapper">
          <Video
            className="size-full"
            contentTitle="or4_sizing_video"
            location="sizing-hero"
            localizedSrc="sizing_gen4_sizing_video_src"
            playVideo={or4VideoVisible}
            preload="metadata"
            type="video/mp4"
            poster="https://ourahealth.imgix.net/sizing/video-poster.png?s=78004f07466bac41c3b7423655ee4fe1"
          />
        </div>
      </div>
    </ModalV3>
  );
};

export default Gen4VideoModal;
